import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import interactiveVideoActions from 'redux/actions/interactiveVideoActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { activityPickerSelector } from 'redux/selectors/interactive_video_creation'
import ActivityPickerModal from 'views/modals/interactive_video_activity_picker_modal'

class InteractiveVideoActivityPickerModalContainer extends PureComponent {

	closeModalHandler = () => {
		this.props.actions.cancelNewActivity(
			this.props.breakpointClientId,
		)
	}

	activityCreationHandler = activityType => {
		this.props.actions.createActivity(
			activityType,
			this.props.breakpointClientId,
		)
	}

	render() {
		return (
			<ActivityPickerModal
				activityList={this.props.activities}
				createHandler={this.activityCreationHandler}
				closeModalHandler={this.closeModalHandler}
			/>
		)
	}

}

function mapStateToProps(state) {
	return activityPickerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		cancelNewActivity: interactiveVideoActions.cancelNewActivity,
		createActivity: interactiveVideoActions.createActivity,
	}, dispatch)
}

InteractiveVideoActivityPickerModalContainer.propTypes = {
	modalName: PropTypes.string.isRequired,
	actions: PropTypes.shape({
		cancelNewActivity: PropTypes.func.isRequired,
		createActivity: PropTypes.func.isRequired,
	}),
	breakpointTime: PropTypes.number,
	breakpointClientId: PropTypes.string,
	activities: PropTypes.array,
}

InteractiveVideoActivityPickerModalContainer.defaultProps = {
	breakpointTime: 0,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	InteractiveVideoActivityPickerModalContainer
)

export { InteractiveVideoActivityPickerModalContainer }
